/**
 * Gets default path from nav bar.
 *
 * @param navBarsWithPermissions
 *
 * @returns */
export const getDefaultPath = (navBarsWithPermissions) => {
  for (const navBar of navBarsWithPermissions) {
    if (navBar.hasPermission) {
      return navBar.path;
    }
  }
};
